import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CreateAdxInvoiceFromFormCommand} from 'src/app/adx-invoice/model/create-adx-invoice-from-form-command';
import {AdxInvoiceService} from 'src/app/adx-invoice/service/adx-invoice.service';

@Component({
    selector: 'app-confirmation-dialog-invoice-form',
    templateUrl: './confirmation-dialog-invoice-form.component.html',
    standalone: false
})

export class ConfirmationDialogInvoiceFormComponent implements OnInit {
    isLoadingSpinner: boolean = false;
    message!: string;
    constructor(
        @Optional() public confirmationDialogRef: MatDialogRef<ConfirmationDialogInvoiceFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adxInvoiceService: AdxInvoiceService,
        private _snackBar: MatSnackBar,
    ){}

    ngOnInit(): void {
      if (this.data.adxInvoiceId){
        this.message = `Are you sure you want to copy invoice "${this.data.adxInvoiceId}"?`;
      }
      else {
        this.message = `Are you sure you want to create a new invoice?`;
      }
    }

    okClick(){
      this.isLoadingSpinner = true;
      
      let createAdxInvoiceFromFormCommand: CreateAdxInvoiceFromFormCommand;

      if (this.data.adxInvoiceId){
        createAdxInvoiceFromFormCommand = {
          adxInvoiceId: this.data.adxInvoiceId
        };
      }
      else{
        createAdxInvoiceFromFormCommand = {
          clientId: this.data.clientId,
          tripId: this.data.tripId,
          branchId: this.data.branchId,
          recordLocator: this.data.recordLocator,
          invoiceTypeCode: this.data.invoiceTypeCode,
          remarks: this.data.remarks,
          invoiceGroup: this.data.invoiceGroup,
          clientCentralDocumentId: this.data.clientCentralDocumentId,
          resCardNumber: this.data.resCardNumber,
          totalAmount: this.data.totalAmount,
          currencyId: this.data.currencyId,
          dataSourceId:this.data.dataSourceId
        };
      }

      this.adxInvoiceService.createAdxInvoiceFromForm(createAdxInvoiceFromFormCommand)
      .subscribe({
          next: (_) => {
            this.isLoadingSpinner = false;
            this._snackBar.open('Invoice created successfully', 'Dismiss', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            }); 
            this.confirmationDialogRef.close(true);
          },
          error: () => {
            this.isLoadingSpinner = false;
            this.confirmationDialogRef.close(true);
          }
      });
    }

    onNoClick(){
        this.confirmationDialogRef.close(false);
    }
}